import { Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { differenceInDays, differenceInHours, differenceInMinutes, differenceInMonths, differenceInYears } from 'date-fns';
import { Observable, of } from 'rxjs';
import { UI_TOOLS_TRANSLOCO_SCOPE } from '../ui-tools-transloco-scope';

type TimeUnit = 'minute' | 'hour' | 'day' | 'month' | 'year';

@Pipe({
  name: 'lastUpdate'
})
export class LastUpdatePipe implements PipeTransform {
  constructor(private translocoService: TranslocoService) {}

  transform(date: Date | null | undefined): Observable<string> {
    const now = Date.now();
    if (date === null || date === undefined) {
      return of('');
    } else if (differenceInMinutes(now, date) < 1) {
      return this.translocoService.selectTranslate('time.lastUpdate.justNow', {}, UI_TOOLS_TRANSLOCO_SCOPE);
    } else if (differenceInHours(now, date) < 1) {
      return this.format(differenceInMinutes(now, date), 'minute');
    } else if (differenceInDays(now, date) < 1) {
      return this.format(differenceInHours(now, date), 'hour');
    } else if (differenceInMonths(now, date) < 1) {
      return this.format(differenceInDays(now, date), 'day');
    } else if (differenceInYears(now, date) < 1) {
      return this.format(differenceInMonths(now, date), 'month');
    } else {
      return this.format(differenceInYears(now, date), 'year');
    }
  }

  private format(amount: number, unit: TimeUnit): Observable<string> {
    return this.translocoService.selectTranslate('time.lastUpdate.timeAgo.' + (amount > 1 ? 'plural' : 'singular'), { amount, unit }, UI_TOOLS_TRANSLOCO_SCOPE);
  }
}
